import { retry, tryCatch } from '@wix/funnel-utils'
import { Dispatch } from 'react'

import { BusinessTermService } from '../../../../reusable/Category/api/BusinessTermService'
import { SearchAction, SearchActionType, SearchLoadCategoriesSuccessAction, SearchSelectCategoryAction } from '../types'

interface LoadCategoriesParams {
  query: string
  businessTermService: BusinessTermService
  language: string
  onLoad?: (categories: Awaited<ReturnType<BusinessTermService['search']>>) => void
  dispatch: Dispatch<SearchAction>
}

const SEARCH_LIMIT = 25

export const loadCategories = async (params: LoadCategoriesParams) => {
  const { query, businessTermService, language, onLoad, dispatch } = params
  dispatch({ type: SearchActionType.SEARCH_LOAD_CATEGORIES_START })

  if (!query) {
    const loadCategoriesSuccessAction: SearchLoadCategoriesSuccessAction = {
      type: SearchActionType.SEARCH_LOAD_CATEGORIES_SUCCESS,
      categories: [],
    }
    return dispatch(loadCategoriesSuccessAction)
  }

  const promise = retry(() => businessTermService.search({ query, limit: SEARCH_LIMIT, language }), {
    retries: 3,
    delayMs: 1000,
  })
  const [, categories = []] = await tryCatch(() => promise)

  void onLoad?.(categories)

  const loadCategoriesSuccessAction: SearchLoadCategoriesSuccessAction = {
    type: SearchActionType.SEARCH_LOAD_CATEGORIES_SUCCESS,
    categories,
  }

  dispatch(loadCategoriesSuccessAction)

  const matchIndex = categories.findIndex(category => category.displayName?.toLowerCase() === query.toLowerCase())
  if (matchIndex >= 0) {
    const businessTermMatch = categories[matchIndex]
    const businessSegmentId = await businessTermService.getBusinessSegmentIdByTermId(
      businessTermMatch.businessTermId || '',
    )
    const selectCategoryAction: SearchSelectCategoryAction = {
      type: SearchActionType.SEARCH_SELECT_CATEGORY,
      category: {
        businessTerm: businessTermMatch,
        businessSegmentId,
        index: matchIndex,
      },
    }
    dispatch(selectCategoryAction)
  }
}
